import React from 'react'
import { Card, CardContent, Grid, TableContainer } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import Divider from '@material-ui/core/Divider'
import { configContext } from '../DnaPlates'
import DeleteAllDialog from '@src/routes/Configurators/components/DeleteDialog'
import { useRouter, dnaPlatesRoute } from '@src/routes'
import {
  ActiveLinkTypeDnaplate,
  PlateProduct,
  Specifications,
  price,
} from '../enum'
import { usePlateSessionFieldMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useGetPlatePriceCallQuery } from '@src/queries/ConfiguratorTubesQuery.generated'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'
import { EmptyState, EmptyPrice } from '../Reducer'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import clsx from 'clsx'
import { priceFormatter } from '@src/routes/Configurators/utils/PriceFormatter'
import Link from '@material-ui/core/Link'
import ValidationWarnings from '../../../validations/ValidationWarnings'
import CircleLoader from '@src/components/CircleLoader'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import DownloadSummary from './DownloadSummary'
import Summary from './Summary'
import OrderSummary from './OrderSummary'
import Paper from '@material-ui/core/Paper'
import styles from '@src/routes/Configurators/utils/styles'
import { dropAllKeyInstances } from '@src/utils/ObjectHelpers/dropKeys'

const useStyles = makeStyles((theme: Theme) => {
  return {
    cardWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(4, 5),
      marginBottom: theme.spacing(4),
      borderRadius: 0,
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
    subHead: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(3),
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: theme.spacing(1.5, 0, 3, 0),
    },
    divider: {
      height: 2,
      marginTop: theme.spacing(2),
      backgroundColor: '#919191',
    },
    dFlex: {
      display: 'flex',
    },
    mgLeft: {
      marginLeft: '30%',
    },
    mgLeftsub: {
      textAlign: 'left',
      paddingLeft: theme.spacing(18),
    },
    mgBottom: {
      marginBottom: theme.spacing(5),
    },
    cardContent: {
      padding: theme.spacing(0),
    },
    deleteMargin: {
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(5),
    },
    label: {
      fontWeight: 'bold',
    },
    deleteButton: {
      padding: theme.spacing(0),
    },
    marginLeft: {
      marginLeft: theme.spacing(6),
    },
    dFlexForZHLang: {
      display: 'flex',
      paddingRight: theme.spacing(4.25),
    },
    tableContainer: {
      maxHeight: 1050,
    },
    warningBox: {
      marginTop: theme.spacing(6),
    },
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2, 6, 4, 10),
      textAlign: 'justify',
    },
    dividerSummary: {
      height: theme.spacing(62),
      marginTop: theme.spacing(30),
      width: theme.spacing(0.5),
      float: 'left',
    },

    deleteIcon: {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.grey[400],
    },

    warningIconPlate: {
      marginLeft: theme.spacing(-1),
    },
  }
})

const OrderTable = (props) => {
  const {
    productDetails,
    updateError,
    configuratorAddToMiniCart,
    setTermsOpen,
  } = props
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, productInformation } = state
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false)
  const [deleteItems, setDeleteItems] = React.useState<any>()
  const [delType, setDelType] = React.useState('')
  const [platesessionField] = usePlateSessionFieldMutation()
  const [scrollBar, setScrollBar] = React.useState(false)
  const router = useRouter()
  const intl = useIntl()
  const warningmsg = [intl.formatMessage(messages.PC_PRICE_ERROR_EMPTY_PRICE)]

  React.useEffect(() => {
    window.scrollTo(0, 0)
    if (sessionData.length > 5) {
      setScrollBar(true)
    } else if (sessionData.length < 6) {
      setScrollBar(false)
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  let priceData: any
  let priceLoading: any
  const FetchPrice = async (obj) => {
    const { data, loading } = useGetPlatePriceCallQuery({
      variables: {
        product: obj,
      },
      fetchPolicy: 'no-cache',
    })
    priceData = data
    priceLoading = loading
  }

  FetchPrice(productDetails)

  React.useEffect(() => {
    if (priceData && !priceData.getPlatePriceCall?.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_PLATE_PRICE',
        data: priceData.getPlatePriceCall.response,
      })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    // TODO: need a test before we refactor these dependencies
  }, [priceData])

  React.useEffect(() => {
    // Added comment for avoid es-lint error
  }, [state.platePriceCall])
  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }

  const classes = useStyles()
  const GlobalCSS = styles()
  const deletePlate = (item, type) => {
    if (type === 'Selected' && sessionData.length !== 1) {
      if (
        item.plateId - 1 === state.currentPlateIndex &&
        sessionData.length - 1 === state.currentPlateIndex &&
        sessionData.length !== 1
      ) {
        dispatch({
          type: 'UPDATE_CURRENT_PLATE_INDEX',
          data: state.currentPlateIndex - 1,
        })
      }
      sessionData.forEach((plate) => {
        if (plate.plateId > item.plateId) {
          plate.plateId = plate.plateId - 1
        }
      })
      const index = sessionData.indexOf(item)
      if (index !== -1) {
        sessionData.splice(index, 1)
        state.platePriceCall.splice(index, 1)
        dispatch({
          type: 'UPDATE_PLATE_PRICE',
          data: [...state.platePriceCall],
        })
      }
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })

      savePlateDataToSession(sessionData)
    } else if (sessionData.length === 1 || type === 'All') {
      if (type === 'All' || sessionData.length === 1) {
        sessionData.splice(0, sessionData.length)
        state.platePriceCall.splice(0, state.platePriceCall.length)
      }
      state.sessionData.push(EmptyState)
      state.platePriceCall.push(EmptyPrice)

      sessionData.forEach((data) => {
        // Drop __typename from the data object and then bind that return to the data on the loop.
        const dataRecast = dropAllKeyInstances(data, ['__typename'])
        data = dataRecast
      })
      dispatch({
        type: 'UPDATE_CURRENT_PLATE_INDEX',
        data: 0,
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({
        type: 'UPDATE_PLATE_PRICE',
        data: [...state.platePriceCall],
      })
      savePlateDataToSession([])
      dispatch({ type: 'SET_STEP_NO', data: 0 })
      const url = `${dnaPlatesRoute.index()}?product=${
        productDetails.productType
      }&activeLink=${ActiveLinkTypeDnaplate.SequenceUpload}`
      router.push(url)
    }
    if (sessionData.length <= 5) {
      setScrollBar(false)
    }
  }

  const performDeleteAll = (type) => {
    setDeleteDialogOpen(true)
    setDeleteItems(sessionData)
    setDelType(type)
  }

  const performDelete = (item, type) => {
    setDeleteDialogOpen(true)
    setDeleteItems(item)
    setDelType(type)
  }
  const oligoNameWarning = () => {
    let count = false

    if (productDetails.productType === PlateProduct.DuplexPlate) {
      sessionData.forEach((item) => {
        item.biTubeWellList.forEach((data) => {
          if (
            (data.name.trim().length > 18 && data.name.trim().length <= 27) ||
            (data.antisenceName.trim().length > 18 &&
              data.antisenceName.trim().length <= 30)
          ) {
            count = true
          }
        })
      })
    } else {
      sessionData.forEach((item) => {
        item.wellList.forEach((data) => {
          if (data.name.trim().length > 18 && data.name.trim().length <= 30) {
            count = true
          }
        })
      })
    }
    return count
  }

  const displaySessionData = (index) => {
    state.currentPlateIndex = index
    dispatch({
      type: 'UPDATE_CURRENT_PLATE_INDEX',
      data: state.currentPlateIndex,
    })
    const path = `${dnaPlatesRoute.index()}?product=${
      productDetails.productType
    }&activeLink=${ActiveLinkTypeDnaplate.OligoConfiguration}`
    router.push(path)
  }
  const totalBaseCount = (currentplate) => {
    let totalBasecount = 0
    if (productDetails.productType === PlateProduct.DuplexPlate) {
      currentplate.biTubeWellList.forEach((data) => {
        totalBasecount =
          totalBasecount + (data.baseCount + data.antisenceBaseCount)
      })
    } else {
      currentplate.wellList.forEach((data) => {
        totalBasecount = totalBasecount + data.baseCount
      })
    }
    return totalBasecount
  }

  const renderData = () => {
    const result: any[] = []
    sessionData.forEach((item, index) => {
      const totalbasecountvalue = totalBaseCount(item)
      result.push(
        <Card className={classes.cardWrapper} key={item.plateId}>
          <CardContent className={classes.cardContent}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="flex-start"
            >
              <div>
                <h4>
                  <Link href="#" onClick={() => displaySessionData(index)}>
                    <strong>{item.plateName}</strong>
                  </Link>
                </h4>

                <div>
                  <span>
                    <label className={GlobalCSS.globalBlackFontColor}>
                      <span>
                        {item.wellType}
                        <FormattedMessage
                          {...messages.CONF_DNAPLATE_VIEWALL_WELL}
                        />
                        {item.channelType}
                        <FormattedMessage
                          {...messages.CONF_DNAPLATE_CONFIRM_CHANNEL_TEXT}
                        />
                        {', '}
                        {item.plateType === Specifications.STANDARD ? (
                          <FormattedMessage
                            {...messages.CONF_DNAPLATE_PLATE_TYPE_STNADARD}
                          />
                        ) : (
                          <FormattedMessage
                            {...messages.CONF_DNAPLATE_PLATE_TYPE_MIXED}
                          />
                        )}
                      </span>
                    </label>
                  </span>
                </div>

                <span>
                  <label className={GlobalCSS.globalBlackFontColor}>
                    {productDetails.productType === PlateProduct.DuplexPlate
                      ? item.biTubeWellList.length
                      : item.wellList.length}{' '}
                    <FormattedMessage
                      {...messages[`CONF_OLIGOS_${productDetails.productType}`]}
                    />
                  </label>
                </span>
              </div>
              <div className={classes.mgLeft}></div>
              <div>
                <Table>
                  <tbody>
                    <tr>
                      <td className={GlobalCSS.globalBlackFontColor}>
                        <FormattedMessage
                          {...messages[
                            `CONF_PLATE_PRODUCT_NUMBER_OF_BASES_TEXT_${productDetails.productType}`
                          ]}
                          values={{ totalbasecountvalue }}
                        />
                      </td>
                      <td align="right">
                        <label
                          className={clsx(
                            GlobalCSS.globalBlackFontColor,
                            classes.marginLeft
                          )}
                        >
                          {state.platePriceCall.length > index
                            ? state.platePriceCall[index].baseFee ===
                              price.priceQuote
                              ? intl.formatMessage(messages._PC_QUOTE_ITEM)
                              : (state.platePriceCall[index]
                                    .priceErrorHeader === null ||
                                    state.platePriceCall[index]
                                      .priceErrorHeader === '') &&
                                  state.platePriceCall[index].baseFee !== ''
                                ? priceFormatter(
                                    state.platePriceCall[index].baseFee,
                                    productInformation.currencyFormat,
                                    productInformation.thousandSeparator,
                                    productInformation.thousandSpacing,
                                    productInformation.decimalSeparator,
                                    productInformation.prefixCurrecny,
                                    state.platePriceCall[index].currencySymbol
                                  )
                                : '--'
                            : '--'}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td className={GlobalCSS.globalBlackFontColor}>
                        <FormattedMessage
                          {...messages.CONF_PURIFICATION_FEE_DNA_PLATES}
                        />
                      </td>
                      <td align="right">
                        <label
                          className={clsx(
                            GlobalCSS.globalBlackFontColor,
                            classes.marginLeft
                          )}
                        >
                          {state.platePriceCall.length > index
                            ? state.platePriceCall[index].purificationFee ===
                              price.priceQuote
                              ? intl.formatMessage(messages._PC_QUOTE_ITEM)
                              : (state.platePriceCall[index]
                                    .priceErrorHeader === null ||
                                    state.platePriceCall[index]
                                      .priceErrorHeader === '') &&
                                  state.platePriceCall[index]
                                    .purificationFee !== ''
                                ? priceFormatter(
                                    state.platePriceCall[index].purificationFee,
                                    productInformation.currencyFormat,
                                    productInformation.thousandSeparator,
                                    productInformation.thousandSpacing,
                                    productInformation.decimalSeparator,
                                    productInformation.prefixCurrecny,
                                    state.platePriceCall[index].currencySymbol
                                  )
                                : '--'
                            : '--'}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td className={GlobalCSS.globalBlackFontColor}>
                        <FormattedMessage
                          {...messages.CONF_MODIFICATION_FEE_DNA_PLATES}
                        />
                      </td>
                      <td align="right">
                        <label
                          className={clsx(
                            GlobalCSS.globalBlackFontColor,
                            classes.marginLeft
                          )}
                        >
                          {state.platePriceCall.length > index
                            ? state.platePriceCall[index].modificationFee ===
                              price.priceQuote
                              ? intl.formatMessage(messages._PC_QUOTE_ITEM)
                              : (state.platePriceCall[index]
                                    .priceErrorHeader === null ||
                                    state.platePriceCall[index]
                                      .priceErrorHeader === '') &&
                                  state.platePriceCall[index]
                                    .modificationFee !== ''
                                ? priceFormatter(
                                    state.platePriceCall[index].modificationFee,
                                    productInformation.currencyFormat,
                                    productInformation.thousandSeparator,
                                    productInformation.thousandSpacing,
                                    productInformation.decimalSeparator,
                                    productInformation.prefixCurrecny,
                                    state.platePriceCall[index].currencySymbol
                                  )
                                : '--'
                            : '--'}
                        </label>
                      </td>
                    </tr>
                    {productDetails.productType !== PlateProduct.DuplexPlate ? (
                      <>
                        {' '}
                        <tr>
                          <td className={GlobalCSS.globalBlackFontColor}>
                            <FormattedMessage
                              {...messages.CONF_PLATE_COPY_FEE_DNA_PLATES}
                            />
                          </td>
                          <td align="right">
                            <label
                              className={clsx(
                                GlobalCSS.globalBlackFontColor,
                                classes.marginLeft
                              )}
                            >
                              {state.platePriceCall.length > index
                                ? state.platePriceCall[index].plateCopyFee ===
                                  price.priceQuote
                                  ? intl.formatMessage(messages._PC_QUOTE_ITEM)
                                  : (state.platePriceCall[index]
                                        .priceErrorHeader === null ||
                                        state.platePriceCall[index]
                                          .priceErrorHeader === '') &&
                                      state.platePriceCall[index]
                                        .plateCopyFee !== ''
                                    ? priceFormatter(
                                        state.platePriceCall[index]
                                          .plateCopyFee,
                                        productInformation.currencyFormat,
                                        productInformation.thousandSeparator,
                                        productInformation.thousandSpacing,
                                        productInformation.decimalSeparator,
                                        productInformation.prefixCurrecny,
                                        state.platePriceCall[index]
                                          .currencySymbol
                                      )
                                    : '--'
                                : '--'}
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td className={GlobalCSS.globalBlackFontColor}>
                            <FormattedMessage
                              {...messages.CONF_OTHERS_DNA_PLATES}
                            />
                          </td>
                          <td align="right">
                            <label
                              className={clsx(
                                GlobalCSS.globalBlackFontColor,
                                classes.marginLeft
                              )}
                            >
                              {state.platePriceCall.length > index
                                ? state.platePriceCall[index]
                                    .remainingMaterials === price.priceQuote
                                  ? intl.formatMessage(messages._PC_QUOTE_ITEM)
                                  : (state.platePriceCall[index]
                                        .priceErrorHeader === null ||
                                        state.platePriceCall[index]
                                          .priceErrorHeader === '') &&
                                      state.platePriceCall[index]
                                        .remainingMaterials !== ''
                                    ? priceFormatter(
                                        state.platePriceCall[index]
                                          .remainingMaterials,
                                        productInformation.currencyFormat,
                                        productInformation.thousandSeparator,
                                        productInformation.thousandSpacing,
                                        productInformation.decimalSeparator,
                                        productInformation.prefixCurrecny,
                                        state.platePriceCall[index]
                                          .currencySymbol
                                      )
                                    : '--'
                                : '--'}
                            </label>
                          </td>
                        </tr>
                      </>
                    ) : (
                      ''
                    )}
                    <tr>
                      <td colSpan={2}>
                        <Divider
                          orientation="horizontal"
                          className={classes.divider}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className={classes.mgLeftsub}>
                        <FormattedMessage
                          {...messages.CONF_PLATE_SUBTOTAL_DNA_PLATES}
                        />
                      </td>
                      <td>
                        <label className={classes.marginLeft}>
                          {state.platePriceCall.length > index
                            ? state.platePriceCall[index].totalPrice ===
                              price.priceQuote
                              ? intl.formatMessage(messages._PC_QUOTE_ITEM)
                              : (state.platePriceCall[index]
                                    .priceErrorHeader === null ||
                                    state.platePriceCall[index]
                                      .priceErrorHeader === '') &&
                                  state.platePriceCall[index].totalPrice !== ''
                                ? priceFormatter(
                                    state.platePriceCall[index].totalPrice,
                                    productInformation.currencyFormat,
                                    productInformation.thousandSeparator,
                                    productInformation.thousandSpacing,
                                    productInformation.decimalSeparator,
                                    productInformation.prefixCurrecny,
                                    state.platePriceCall[index].currencySymbol
                                  )
                                : '--'
                            : '--'}
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <div>
                <span>
                  <IconButton
                    aria-label="delete"
                    className={classes.deleteButton}
                    onClick={() => performDelete(item, 'Selected')}
                  >
                    <DeleteIcon className={classes.deleteIcon} />
                  </IconButton>
                </span>
              </div>
            </Grid>
          </CardContent>
        </Card>
      )
    })
    return result
  }

  return (
    <>
      <div className={classes.subHead}>
        <FormattedMessage {...messages.CONF_CONFIRM_ORDER_DNA_PLATES} />
      </div>
      {oligoNameWarning() ? (
        <Grid>
          <Grid className={GlobalCSS.WellSectionText}>
            <div className={GlobalCSS.textLeft}>
              {' '}
              <span>
                {' '}
                <WarningRoundedIcon
                  color="primary"
                  className={clsx(
                    GlobalCSS.warningIcon,
                    classes.warningIconPlate
                  )}
                ></WarningRoundedIcon>
              </span>
              <span className={GlobalCSS.messageText}>
                {' '}
                <FormattedMessage
                  {...messages.CONF_WARNING_MESSAGE}
                ></FormattedMessage>
              </span>
            </div>
            <div className={GlobalCSS.overflow}>
              <span>
                {' '}
                <FormattedMessage {...messages.CONF_OLIGO_NAME_PLATE_WARNING} />
              </span>
            </div>
          </Grid>
        </Grid>
      ) : (
        ''
      )}

      <div className={classes.header}>
        <div>
          <FormattedMessage {...messages.CONF_PLATE_TOTAL_COUNT} />
          <span>{sessionData.length}</span>
        </div>
        <div className={scrollBar ? classes.dFlexForZHLang : classes.dFlex}>
          <strong className={GlobalCSS.globalBlackFontColor}>
            <FormattedMessage {...messages.CONF_DELETE_ALL_BUTTON} />
          </strong>
          <span className={classes.deleteMargin}>
            <IconButton
              aria-label="delete"
              onClick={() => performDeleteAll('All')}
              className={classes.deleteButton}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </span>
        </div>
      </div>
      <TableContainer className={scrollBar ? classes.tableContainer : ''}>
        {renderData()}
      </TableContainer>
      {state.platePriceCall.length !== 0 ? (
        state.platePriceCall[0].priceErrorHeader !== null ? (
          state.platePriceCall[0].priceErrorHeader.length !== 0 ? (
            <div className={classes.warningBox}>
              <ValidationWarnings warnings={warningmsg} />
            </div>
          ) : (
            ''
          )
        ) : (
          ''
        )
      ) : (
        ''
      )}
      <DownloadSummary productDetails={productDetails} />
      <Paper className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={5}>
            <OrderSummary productDetails={productDetails} />
          </Grid>
          <Grid item xs={7}>
            <Divider
              orientation="vertical"
              className={classes.dividerSummary}
            />
            <Summary
              productDetails={productDetails}
              updateError={updateError}
              configuratorAddToMiniCart={configuratorAddToMiniCart}
              setTermsOpen={setTermsOpen}
            />
          </Grid>
        </Grid>
      </Paper>
      <DeleteAllDialog
        dialogOpen={deleteDialogOpen}
        setDialogOpen={setDeleteDialogOpen}
        type={delType}
        selectedItem={deleteItems}
        onDelete={deletePlate}
      />
      {priceLoading && <CircleLoader />}
    </>
  )
}

export default OrderTable
